import { validatenull } from './validate.js'

// 设置Storage
export function setStore(name,content,type){
	const param = {
		dataType: typeof (content),
		content: content,
		type: type,
		datetime: new Date().getTime()
	}
	if (type) sessionStorage.setItem(name, JSON.stringify(param))
	else localStorage.setItem(name, JSON.stringify(param))
}

//获取Storage
export function getStore(name){
	let obj = sessionStorage.getItem(name);
	if(validatenull(obj)) obj = localStorage.getItem(name)
	if(validatenull(obj)) return	
	obj = JSON.parse(obj);
	let content;	
	switch(obj.dataType){
		case 'string':
			content = obj.content;
			break;
		case 'number':
			content = Number(obj.content);
			break;
		case 'boolean':
			content = eval(obj.content);
			break;
		case 'object':
			content = obj.content;
			break;
	}
	return content
}

//删除Storage
export function removeStore(name,type){
	if (type) {
		sessionStorage.removeItem(name)
	} else {
		localStorage.removeItem(name)
	}
}

//获取全部Storage
export function getAllStore(type){
	let list = []
	if (type) {
		for (let i = 0; i <= sessionStorage.length; i++) {
			list.push({
				name: sessionStorage.key(i),
				content: getStore({
					name: sessionStorage.key(i),
					type: 'session'
				})
			})
		}
	} else {
		for (let i = 0; i <= localStorage.length; i++) {
			list.push({
				name: localStorage.key(i),
				content: getStore({
					name: localStorage.key(i)
				})
			})
		}
	}
	return list
}

//清空全部Storage
export function clearStore(type){
	if (type) {
		sessionStorage.clear()
	} else {
		localStorage.clear()
	}
}
